import angular from 'angular';

module.exports = angular.module('common.filters.customer', [
  require('./tel')
])
.filter('customer', function(telFilter) {
  return function(customer) {
    return customer.full_name ||
           (customer.primary_email_data || {}).value ||
           telFilter((customer.primary_phone_number_data || {}).value) ||
           telFilter(customer.mobile_phone_number) ||
           'Unknown Customer';
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/customer.js
 **/